import script from "./cnsEditAffiliationNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./cnsEditAffiliationNumber.vue?vue&type=script&setup=true&lang=ts"

import "./cnsEditAffiliationNumber.vue?vue&type=style&index=0&id=fe1f484c&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe1f484c"]])

export default __exports__